import {
  Button,
  Carousel,
  FileInput,
  Modal,
  Select,
  TextInput,
  Textarea,
} from 'flowbite-react';
import { SitePage } from '../../Models/SitePage';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { fetchPageTypes } from '../../Actions/CommonFields';
import { toast } from 'react-toastify';
import SitePageApi from '../../Api/SitePageApi';
import Loader from '../Common/Loader';
import Editor from '../Common/Editor';
import CommonApi from '../../Api/CommonApi';
import { File as ImageFile } from '../../Models/File';
import { MdCancel } from 'react-icons/md';
import { PageType } from '../../Enums/PageType';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export default function EditSitePage({
  selectedSitePage,
  show,
  setShow,
}: {
  selectedSitePage: number | null;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const { pageTypes } = useAppSelector((state) => state.commonFields);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [quillValue, setQuillValue] = useState('');
  const [file, setFile] = useState<File | null>();
  const [imageFiles, setImageFiles] = useState<ImageFile[]>([]);
  const [formData, setFormData] = useState<SitePage>({
    id: 0,
    pageTypeId: 0,
    title: '',
    header: '',
    description: '',
    metaData: '',
    active: null,

    pageType: null,
    // files: null,
  });

  const getReferences = async () => {
    if (!pageTypes.length) {
      await Promise.all([dispatch(fetchPageTypes())]);
      //   setIsLoading(false);
    } else {
      //   setIsLoading(false);
    }
  };

  useEffect(() => {
    getReferences();
  }, []);

  useEffect(() => {
    if (show) {
      if (selectedSitePage === null) handleSetInitialValues();
      else UpdateFormData();
    }
  }, [show]);

  const UpdateFormData = () => {
    try {
      if (selectedSitePage) {
        SitePageApi.getSitePage(selectedSitePage?.toString())
          .then((res) => {
            if (res.data !== null) {
              setFormData(res.data);
            }
            if (res.data?.description) {
              setQuillValue(
                res.data.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
              );
            }
          })
          .catch((err) => {
            toast.error('Error: ' + err);
          });
        CommonApi.GetFilesBySitePage(selectedSitePage)
          .then((res) => {
            if (res.data !== null) setImageFiles(res.data as ImageFile[]);
          })
          .catch((err) => {
            toast.error('Error: ' + err);
          });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ align: ['right', 'center', 'justify'] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      ['link'],
      [{ color: ['red', '#785412'] }],
      [{ background: ['yellow', 'red', '#785412'] }],
      ['clean'],
    ],
    htmlEditButton: {
      msg: 'Edit the content in HTML format', //Custom message to display in the editor, default: Edit HTML here, when you click "OK" the quill editor's contents will be replaced
      okText: 'Ok', // Text to display in the OK button, default: Ok,
      cancelText: 'Cancel', // Text to display in the cancel button, default: Cancel
      buttonHTML: 'HTML', // Text to display in the toolbar button, default: <>
      buttonTitle: 'Show HTML source', // Text to display as the tooltip for the toolbar button, default: Show HTML source
      syntax: false, // Show the HTML with syntax highlighting. Requires highlightjs on window.hljs (similar to Quill itself), default: false
      prependSelector: 'div#myelement', // a string used to select where you want to insert the overlayContainer, default: null (appends to body),
      editorModules: {}, // The default mod
    },
  };

  const formats = [
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'color',
    'background',
    'align',
  ];

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  function handleImageChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget.files) {
      setFile(event.currentTarget.files[0]);
    } else {
      setFile(null);
    }
  }

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    setButtonDisabled(true);
    e.preventDefault();
    formData.description = quillValue;
    let sitePageUpdated = false;
    let imageUpdated = false;
    try {
      //   setIsLoading(true);
      await SitePageApi.addUpdateSitePage(formData)
        .then((res) => {
          sitePageUpdated = true;
        })
        .catch((err) => {
          toast.error('Error: ' + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
      if (file) {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('name', formData.title ?? '');
        fd.append('sitePageId', formData.id.toString());
        fd.append('description', '');
        await CommonApi.addFile(fd)
          .then((res) => {
            if (res.data.success) {
              imageUpdated = true;
            }
          })
          .catch((err) => {
            toast.error('Image Error: ' + err);
          });
      } else {
        imageUpdated = true;
      }
      setIsLoading(false);
      setButtonDisabled(false);
      if (sitePageUpdated && imageUpdated) {
        toast.success('Save Success');
        setShow(false);
      } else {
        toast.error('Error while saving');
      }
      return;
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  const handleSetInitialValues = () => {
    const values = formData
      ? {
          ...formData,
        }
      : {
          id: 0,
          pageTypeId: 0,
          title: '',
          header: '',
          description: '',
          metaData: '',
          active: null,
          pageType: null,
          // files: null,
        };

    // setImageFiles(values.files as ImageFile[]);
    setFormData(values as SitePage);
  };

  function handleRemoveImage(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this image?'
    );

    if (shouldRemove && imageFiles) {
      CommonApi.deleteFile(id)
        .then((res) => {
          if (res.data.success) {
            setImageFiles(imageFiles.filter((x) => x.id !== id));
            toast.success('Image deleted');
          } else {
            toast.success('Error while deleting image');
          }
        })
        .catch((err) => {
          toast.error('Image Error: ' + err);
        });
    }
  }

  function onCloseModal() {
    setShow(false);
    setFile(null);
    setQuillValue('');
    setFormData({
      id: 0,
      pageTypeId: 0,
      title: '',
      header: '',
      description: '',
      metaData: '',
      active: null,
      pageType: null,
      // files: null,
    });
  }
  return (
    <Modal show={show} size='6xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full mb-2 text-center'>
            <h1 className='text-gray-900 font-bold text-4xl'>Edit Page</h1>
          </div>

          <form onSubmit={onSubmit}>
            <div className='text-gray-500'>
              <div className='grid grid-cols-[20%_80%] text-xl'>
                <div className='flex'>
                  <div className='font-bold content-center'>Title:</div>
                </div>
                <div className='flex'>
                  <div className='w-2/3'>
                    <TextInput
                      id='title'
                      name='title'
                      type='text'
                      placeholder='Title...'
                      onChange={handleChangeInput}
                      value={formData.title ?? ''}
                      sizing='md'
                      disabled
                    />
                  </div>
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[20%_80%] text-xl'>
                <div className='flex'>
                  <div className='font-bold content-center'>Header:</div>
                </div>
                <div className='w-2/3'>
                  <TextInput
                    id='header'
                    name='header'
                    type='text'
                    placeholder='Header...'
                    onChange={handleChangeInput}
                    value={formData.header ?? ''}
                    sizing='md'
                  />
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[20%_80%] text-xl'>
                <div className='flex'>
                  <div className='font-bold content-center'>HTML:</div>
                </div>
                <div className=''>
                  <Editor
                    id='description'
                    name='description'
                    value={quillValue}
                    className='w-full'
                    changedValue={setQuillValue}
                  />
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[20%_80%] text-xl'>
                <div className='flex'>
                  <div className='font-bold content-center'>Meta Data:</div>
                </div>
                <div className=''>
                  <TextInput
                    id='metaData'
                    name='metaData'
                    type='text'
                    placeholder='MetaData...'
                    onChange={handleChangeInput}
                    value={formData.metaData ?? ''}
                    sizing='md'
                  />
                </div>
              </div>

              <hr className='bg-gray-300 h-[2px]'></hr>
              {formData.id > 0 && formData.pageTypeId === PageType.HomePage && (
                <div className='grid grid-cols-[20%_80%] text-xl'>
                  <div className='font-bold content-center'>Slider Photos:</div>
                  <div className='flex flex-col m-2'>
                    {imageFiles && imageFiles.length > 0 && (
                      <Carousel
                        slide={false}
                        className=''
                        leftControl={
                          <div className='rounded-full bg-white opacity-80 p-2 border-2'>
                            <FaChevronLeft size={30} />
                          </div>
                        }
                        rightControl={
                          <div className='rounded-full bg-white opacity-80 p-2 border-2'>
                            <FaChevronRight size={30} />
                          </div>
                        }
                      >
                        {imageFiles.map((data) => (
                          <div key={data.id + '-div'} className='relative'>
                            <div className='w-full text-center absolute top-2'>
                              <button
                                key={data.id + '-button'}
                                type='button'
                                title='Delete Image'
                                onClick={() => handleRemoveImage(data.id)}
                                className=' rounded-full bg-white'
                              >
                                <MdCancel color='red' size={20} />
                              </button>
                            </div>
                            <div className=''>
                              <img
                                key={data.id}
                                src={data.fileUrl!}
                                alt={formData.title + '-image'}
                                className='h-56 sm:h-64 xl:h-80 2xl:h-96 object-contain m-auto'
                              />
                            </div>
                          </div>
                        ))}
                      </Carousel>
                    )}
                    <FileInput
                      id='file-upload'
                      helperText='PNG or JPG.'
                      onChange={handleImageChange}
                      disabled={buttonDisabled}
                      className='m-2'
                    />
                  </div>
                </div>
              )}
              <div className='flex justify-end pt-2'>
                <Button
                  disabled={buttonDisabled}
                  type='submit'
                  className='buttonMain'
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </div>
        {isLoading && <Loader />}
      </Modal.Body>
    </Modal>
  );
}
